module.exports = "\n<div [formGroup]=\"form\">\n\n  <input type=\"text\" formControlName=\"va\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form/template/commerce-login-template/commerce-login-template.component.html
// module id = 1142
// module chunks = 0